import './DropDown.scss'

import React, { useState, useRef, MouseEvent } from 'react'
import classNames from 'classnames'
import { isFunction } from 'lodash'

import useEventListener from '../hooks/useEventListener'

interface Props {
  buttonId: string
  title: string
  items: Array<{
    label: string
    value: number | string
  }>
  className?: string
  onClick?: (v?: any) => void
  onSelect: (value: string) => void
}

export default function DropDown({ buttonId, title, items, className, onClick, onSelect }: Props) {
  const [isActive, setMenuActive] = useState(false)
  const $buttonRef = useRef(null)
  const isActiveRef = useRef(isActive)

  const toggleMenu = () =>
    setMenuActive(prevActiveState => {
      isActiveRef.current = !prevActiveState
      if (isFunction(onClick)) {
        onClick(!prevActiveState)
      }
      return !prevActiveState
    })

  const setMenuActiveStatus = (status: boolean) => {
    isActiveRef.current = status
    setMenuActive(status)
  }

  useEventListener([
    {
      eventName: 'click',
      callback: e => {
        const $buttonEl = $buttonRef.current
        if (isActiveRef.current && e.target !== $buttonEl) {
          setMenuActiveStatus(false)
          if (isFunction(onClick)) {
            onClick(false)
          }
        }
      },
    },
  ])

  const handleSelect = (e: MouseEvent<HTMLUListElement>) => {
    e.preventDefault()
    e.stopPropagation()
    const $liEl = e.target as HTMLLIElement
    const value = $liEl.getAttribute('data-value')
    onSelect(value || '')
    setMenuActiveStatus(false)
    if (isFunction(onClick)) {
      onClick(false)
    }
  }

  return (
    <div
      className={classNames('DropDown', className, {
        'DropDown--active': isActive,
      })}
    >
      <button id={`${buttonId}DropdownToggle`} ref={$buttonRef} className="DropDown__button" onClick={toggleMenu}>
        {title}
      </button>
      {isActive && (
        <ul className="DropDown__items" onClick={handleSelect}>
          {items.map(({ label, value }) => (
            <li id={'SelectDropDown'} className="DropDown__item" key={label} data-value={value}>
              {label}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
